import React from "react";
import image_1 from "../../images/agriculture/Picture2.webp";
import image_2 from "../../images/agriculture/Picture35.webp";
import image_3 from "../../images/agriculture/Picture36.webp";
import image_4 from "../../images/agriculture/Picture37.webp";
import image_5 from "../../images/agriculture/Picture38.webp";
import image_6 from "../../images/agriculture/Picture39.webp";

const imgData = [
  {
    id: 1,
    image: image_2,
  },
  {
    id: 2,
    image: image_3,
  },
  {
    id: 3,
    image: image_4,
  },
  {
    id: 4,
    image: image_5,
  },
  {
    id: 5,
    image: image_6,
  },
];

const OurBrands = () => {
  return (
    <section id="our-brands">
      <div className="our-brands-container">
        <div className="ms-13 me-13 pt-7 pb-7 text-center">
          <img src={image_1} className="img-fluid" alt="" />
          <h1 className="fs-56 lh-64 text-uppercase gilroy-bold text-white pt-5">
            Our Brands
          </h1>
        </div>
      </div>
      <div className="bg-chinese-black">
        <div className="ms-47 me-47 pt-7 pb-7">
          <div className="row">
            <div className="col-md-4 col-xl-4">
              {imgData.map((data) => (
                <div
                  className="our-brand-img-container text-center bg-white"
                  key={data?.id}
                >
                  <img
                    src={data?.image}
                    className="img-fluid card-design-2"
                    alt=""
                  />
                </div>
              ))}
            </div>
            <div className="col-md-8 col-xl-8">
              <div className="our-brand-content-container bg-white">
                <h2 className="fs-28 gilroy-bold text-orange-ryb py-5">
                  From the farm to customers
                </h2>
                <p className="fs-20 lh-30 text-align-justify">
                  SEGAM Agriculture & Trade strength is in its integration.
                  Since the majority of the orchards are long-term suppliers and
                  fair – trade partners with SEGAM Trade & exports, we have our
                  finger on the pulse every single stage of the way. When it
                  comes to quality control and supply, our deep integration from
                  the farm to the customers allows us to offer the highest
                  quality produce and service at every step of the process. We
                  know exactly what comes in and what is shipped out.
                </p>
                <p className="fs-20 lh-30 text-align-justify">
                  SEGAM Agriculture & Trade packaging houses closely monitors
                  all raw materials and produce that comes into its packaging
                  houses – down to the finest resolution. Every fruit, citrus
                  and vegetable is carefully selected and allocated to a
                  specific client – giving us the flexibility to offer specific
                  produce and packaging solutions for each individual client.
                  Our packaging houses are on the forefront of cutting edge
                  technology using the best systems to make the logistical
                  process as efficient as possible. The advanced best sorting
                  systems allow us to finely classify the fruit according to
                  colour and size – that way our clients know that they will
                  receive exactly what they ordered.
                </p>
                <h3 className="fs-28 gilroy-bold text-orange-ryb py-5">
                  Packaged to perfection
                </h3>
                <p className="fs-20 lh-30 text-align-justify">
                  SEGAM Agriculture & Trade specializes in all styles and sizes
                  of packaging – from large size containers for shipping,
                  through uniquely designed packages ready to be opened in the
                  end consumer’s home. Our ability to offer the widest variety
                  of packaging solutions for all clients, while knowing what is
                  in every single package – down to what plot the produce came
                  from, makes us one of the most trusted growers and exporters
                  in the world.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurBrands;
